/* istanbul ignore next */
export { default } from './ChooseYourNumber';
